import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Hub } from 'aws-amplify/utils';
import * as actions from '../../store/actions';

/**
 *
 * Hub.listen('auth', ({ payload: { event, data } }) => {
 *   switch (event) {
 *     default:
 *       console.log('Unknown auth event', event, data);
 *       break;
 *   }
 * });
 * config.configureAmplify(amplifyConfig);
 */
export const useSignInFederateEffect = (handleSignIn) => {
  const dispatch = useDispatch();
  useEffect(() => {
    console.log('[useSignInFederateEffect] Registering Hub listener for auth events');
    
    const unsubscribe = Hub.listen('auth', ({ payload: { event, data } }) => {
      console.log('[useSignInFederateEffect] Received auth event:', event, data);
      
      switch (event) {
        case 'signIn':
        case 'signedIn':
        case 'signInWithRedirect': // Amplify v6 OAuth callback event
          console.log('[useSignInFederateEffect] Calling handleSignIn with data:', data);
          handleSignIn(data, true);
          break;
        case 'signIn_failure':
        case 'signInWithRedirect_failure': // Amplify v6 OAuth failure event
          console.log('[useSignInFederateEffect] Sign in failed:', data);
          dispatch(actions.handleSignInError({ event, data }));
          break;
        default:
          console.log('[useSignInFederateEffect] Unhandled auth event:', event, data);
          break;
      }
    });
    
    return () => {
      console.log('[useSignInFederateEffect] Cleaning up Hub listener');
      unsubscribe();
    };
  }, [dispatch, handleSignIn]);
}
